export class ApiError extends Error {
  status: number
  payload: unknown
  constructor(status: number, message: string, payload: unknown) {
    super(message)
    this.status = status
    this.payload = payload
  }
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: "include",
    ...init,
    headers: {
      "content-type": "application/json",
      ...init?.headers,
    },
  })

  if (res.status === 401 && !path.startsWith("/api/auth/")) {
    const next = encodeURIComponent(window.location.pathname + window.location.search)
    window.location.replace(`/login?next=${next}`)
    throw new ApiError(401, "unauthorized", null)
  }

  const ct = res.headers.get("content-type") ?? ""
  const body = ct.includes("application/json") ? await res.json() : await res.text()

  if (!res.ok) {
    const msg =
      typeof body === "object" && body && "error" in body
        ? String((body as { error: unknown }).error)
        : `HTTP ${res.status}`
    throw new ApiError(res.status, msg, body)
  }

  return body as T
}

export function buildQuery(params: Record<string, string | number | undefined | null>): string {
  const qs = new URLSearchParams()
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === "") continue
    qs.set(k, String(v))
  }
  const s = qs.toString()
  return s ? `?${s}` : ""
}
